import { createContext } from 'react';
import { TPartnerConfigurationDetails } from 'typings/partner';

export const ConfigContext = createContext<TPartnerConfigurationDetails>({});
